export const translations = {
  en: {
    welcome: "Welcome to MISK Learning Center",
    subtitle: "Islamic Education Center - Kuwait",
    welcomeMessage: "MISK Learning Center is dedicated to providing quality Islamic education to students in Kuwait. We offer comprehensive programs that combine traditional Islamic teachings with modern educational approaches.",
    registerStudent: "Register New Student",
    staffLogin: "Staff Login",
    ourPrograms: "Our Programs",
    quranMemorization: "Quran Memorization (Hifz)",
    islamicStudies: "Islamic Studies",
    arabicLanguage: "Arabic Language",
    tajweedClasses: "Tajweed Classes",
    dashboard: "Dashboard", logout: "Logout", studentApplications: "Student Applications",
    studentName: "Student Name", fatherName: "Father Name", dateOfBirth: "Date of Birth",
    area: "Area", contactNumber: "Contact", status: "Status", actions: "Actions",
    viewDetails: "View Details", studentDetails: "Student Details", gender: "Gender",
    nationality: "Nationality", email: "Email", addressInKuwait: "Address in Kuwait",
    nativeAddress: "Native Address", civilIdStudent: "Civil ID (Student)",
    civilIdParent: "Civil ID (Parent)", reviewedBy: "Reviewed By",
    addComments: "Add Comments", approve: "Approve", reject: "Reject",
    pending: "PENDING", approved: "APPROVED", rejected: "REJECTED",
    transportRequired: "Is Transport Required?",
    transportMessage: "Alhamdulillah (Praise be to Allah), the education program itself is offered completely free of charge. To support the logistics and ensure all interested individuals can attend, we are seeking voluntary contributions toward transport expenses from those who are able to provide or sponsor their own transport. If you are able to contribute towards your transport costs, or have the means to arrange it independently, please indicate below. This will help us manage resources and prioritize support for those in genuine need of assistance.",
    transportCanCover: "Tabarru - I can cover",
    transportCannotCover: "Can't Afford, Need support (Allah is Sufficient)",
    transportSelfArranged: "No, I can take care of the transport.",
    interestedInDonation: "Am I interested in doing sadaqah or a voluntary contribution/donation for this learning center?",
    transportOption: "Transport Option",
    yes: "Yes", no: "No"
  },
  ta: {
    welcome: "MISK கற்றல் மையத்திற்கு வரவேற்கிறோம்",
    subtitle: "இஸ்லாமிய கல்வி மையம் - குவைத்",
    welcomeMessage: "MISK கற்றல் மையம் குவைத்தில் உள்ள மாணவர்களுக்கு தரமான இஸ்லாமிய கல்வியை வழங்குவதில் அர்ப்பணிப்புடன் உள்ளது. பாரம்பரிய இஸ்லாமிய போதனைகளை நவீன கல்வி அணுகுமுறைகளுடன் இணைக்கும் விரிவான திட்டங்களை நாங்கள் வழங்குகிறோம்.",
    registerStudent: "புதிய மாணவர் பதிவு",
    staffLogin: "ஊழியர் உள்நுழைவு",
    ourPrograms: "எங்கள் திட்டங்கள்",
    quranMemorization: "குர்ஆன் மனனம் (ஹிஃப்ஸ்)",
    islamicStudies: "இஸ்லாமிய படிப்புகள்",
    arabicLanguage: "அரபு மொழி",
    tajweedClasses: "தஜ்வீத் வகுப்புகள்",
    dashboard: "டாஷ்போர்டு", logout: "வெளியேறு", studentApplications: "மாணவர் விண்ணப்பங்கள்",
    studentName: "மாணவர் பெயர்", fatherName: "தந்தை பெயர்", dateOfBirth: "பிறந்த தேதி",
    area: "பகுதி", contactNumber: "தொடர்பு", status: "நிலை", actions: "செயல்கள்",
    viewDetails: "விவரங்களைக் காண்க", studentDetails: "மாணவர் விவரங்கள்", gender: "பாலினம்",
    nationality: "தேசியம்", email: "மின்னஞ்சல்", addressInKuwait: "குவைத்தில் முகவரி",
    nativeAddress: "சொந்த முகவரி", civilIdStudent: "சிவில் ஐடி (மாணவர்)",
    civilIdParent: "சிவில் ஐடி (பெற்றோர்)", reviewedBy: "மதிப்பாய்வு செய்தவர்",
    addComments: "கருத்துகளைச் சேர்க்கவும்", approve: "அங்கீகரி", reject: "நிராகரி",
    pending: "நிலுவையில்", approved: "அங்கீகரிக்கப்பட்டது", rejected: "நிராகரிக்கப்பட்டது",
    transportRequired: "போக்குவரத்து தேவையா?",
    transportMessage: "அல்ஹம்துலில்லாஹ் (அல்லாஹ்வுக்கே புகழனைத்தும்), கல்வித் திட்டம் முற்றிலும் இலவசமாக வழங்கப்படுகிறது. தளவாடங்களை ஆதரிக்கவும், ஆர்வமுள்ள அனைவரும் கலந்துகொள்ள உறுதி செய்யவும், சொந்த போக்குவரத்தை வழங்க அல்லது நிதியுதவி செய்ய முடியும் என்பவர்களிடமிருந்து போக்குவரத்து செலவுகளுக்கான தன்னார்வ பங்களிப்புகளை நாங்கள் கோருகிறோம். உங்கள் போக்குவரத்து செலவுகளுக்கு பங்களிக்க முடிந்தால், அல்லது சுயாதீனமாக ஏற்பாடு செய்ய வழி இருந்தால், கீழே குறிப்பிடவும். இது எங்களுக்கு வளங்களை நிர்வகிக்கவும், உண்மையான உதவி தேவைப்படுபவர்களுக்கு முன்னுரிமை அளிக்கவும் உதவும்.",
    transportCanCover: "தபர்ரு - நான் செலுத்த முடியும்",
    transportCannotCover: "வாங்க முடியாது, ஆதரவு தேவை (அல்லாஹ் போதுமானவன்)",
    transportSelfArranged: "இல்லை, நான் போக்குவரத்தை கவனித்துக் கொள்ள முடியும்.",
    interestedInDonation: "இந்த கற்றல் மையத்திற்கு ஸதகா அல்லது தன்னார்வ பங்களிப்பு/நன்கொடை செய்ய நான் ஆர்வமாக உள்ளேனா?",
    transportOption: "போக்குவரத்து விருப்பம்",
    yes: "ஆம்", no: "இல்லை"
  },
  ar: {
    welcome: "مرحبا بكم في مركز مسك التعليمي",
    subtitle: "مركز التعليم الإسلامي - الكويت",
    welcomeMessage: "يلتزم مركز مسك التعليمي بتوفير تعليم إسلامي عالي الجودة للطلاب في الكويت. نحن نقدم برامج شاملة تجمع بين التعاليم الإسلامية التقليدية والأساليب التعليمية الحديثة.",
    registerStudent: "تسجيل طالب جديد",
    staffLogin: "تسجيل دخول الموظفين",
    ourPrograms: "برامجنا",
    quranMemorization: "حفظ القرآن",
    islamicStudies: "الدراسات الإسلامية",
    arabicLanguage: "اللغة العربية",
    tajweedClasses: "دروس التجويد",
    dashboard: "لوحة التحكم", logout: "تسجيل الخروج", studentApplications: "طلبات الطلاب",
    studentName: "اسم الطالب", fatherName: "اسم الأب", dateOfBirth: "تاريخ الميلاد",
    area: "المنطقة", contactNumber: "الاتصال", status: "الحالة", actions: "الإجراءات",
    viewDetails: "عرض التفاصيل", studentDetails: "تفاصيل الطالب", gender: "الجنس",
    nationality: "الجنسية", email: "البريد الإلكتروني", addressInKuwait: "العنوان في الكويت",
    nativeAddress: "العنوان الأصلي", civilIdStudent: "البطاقة المدنية (الطالب)",
    civilIdParent: "البطاقة المدنية (ولي الأمر)", reviewedBy: "تمت المراجعة بواسطة",
    addComments: "إضافة تعليقات", approve: "موافقة", reject: "رفض",
    pending: "قيد الانتظار", approved: "تمت الموافقة", rejected: "مرفوض",
    transportRequired: "هل النقل مطلوب؟",
    transportMessage: "الحمد لله، يتم تقديم البرنامج التعليمي نفسه مجانًا تمامًا. لدعم اللوجستيات وضمان حضور جميع المهتمين، نسعى للحصول على مساهمات طوعية لنفقات النقل من أولئك القادرين على توفير أو رعاية وسائل النقل الخاصة بهم. إذا كنت قادرًا على المساهمة في تكاليف النقل الخاصة بك، أو لديك الوسائل لترتيبها بشكل مستقل، يرجى الإشارة أدناه. سيساعدنا هذا في إدارة الموارد وإعطاء الأولوية للدعم لأولئك الذين هم في حاجة حقيقية للمساعدة.",
    transportCanCover: "تبرع - يمكنني التغطية",
    transportCannotCover: "لا أستطيع تحمل التكلفة، أحتاج الدعم (الله كافٍ)",
    transportSelfArranged: "لا، يمكنني الاعتناء بالنقل.",
    interestedInDonation: "هل أنا مهتم بالصدقة أو المساهمة/التبرع الطوعي لهذا المركز التعليمي؟",
    transportOption: "خيار النقل",
    yes: "نعم", no: "لا"
  }
};
